export default "__VITE_ASSET__bFUVrLI3__"